/*
 *  Document   : consultant_candidates.js
 *  Author     : Exapoint
 *
 */

// Import required modules
import ExaHelpers from "../exa_helpers";

export default class ConsultantCandidates {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ConsultantCandidates"] = this;
        this.init();
    }

    init() {
        var table = $('.js-dataTable-full-pagination').DataTable({
            ajax: datatablesAjax,
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {
                    data: "user.full_name",
                    render: function (data, type, row) {
                        let profilePictureUrl = row.user.profile_picture ? `${Laravel.app_url}/storage/${row.user.profile_picture}` : `${Laravel.app_url}/media/avatars/exa_avatar_placeholder.jpg`;
                        // let profilePictureUrl = row.user.profile_picture ? `${Laravel.app_url}/storage/${row.user.profile_picture}` : `${Laravel.app_url}/media/avatars/exa_avatar_placeholder.jpg`;
                        return `
                        <a href="#" class="empty-link td-user-picture" data-target="#consultant-activities-edit-user-modal"
                            data-remote="${jsVars.candidateEditUrl.replace(':id', row.user.id)}" data-toggle="modal">
                            <div style="background-image: url('${profilePictureUrl}')" class="img-avatar img-avatar-thumb"></div>
                            <span>${row.user.full_name}</span>
                        </a>`;
                    }
                },
                { data: null },
                {
                    data: "user.email",
                    render: function(data, type, row) {
                        return `<a href="mailto:${data ? data : ''}" class="text-color-table">${data ? data : ''}</a>`
                    }
                },
                {
                    data: "user.mobile_number",
                    render: function(data, type, row) {
                        return `<a href="tel:${data ? data : ''}" class="text-color-table">${data ? data : ''}</a>`
                    }
                },
                { data: "user.location" },
                {
                    data: null,
                    render: function (data, type, row) {
                        let html = jsVars.noRatingYetText;
                        html = ExaHelpers.ratingToIcons(row.user.rating_value) + ' ' + (row.user.rating_value ?? 0) + ' ' + '(' +row.user.rating_count + ')';

                        if (row.user.bad_rating_count) {
                            html += `<br />Ne s'est pas présenté(e) : ${row.user.bad_rating_count}`;
                        }
                        return `<div class="d-inline text-nowrap">${html}</div>`;
                        // return html
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        // return !row.user.operator_id ? `
                        return 1 === 1 ? `
                        <form action="${jsVars.makeMeOperatorUrl.replace(':user-id', row.user.id)}" method="POST">
                            <input type="hidden" name="_token" value="${Laravel.csrfToken}"/>
                            <button class="btn btn-outline-primary btn-small">${jsVars.makeMeOperatorText}</button>
                        </form>` : '';
                    }
                },
                {
                    data: "is_manpower",
                    render: function (data, type, row) {
                        return (row.is_manpower == 0) ? "non" : "oui";
                    }
                },
                {
                    data: "is_volunteer",
                    render: function (data, type, row) {
                        return (row.is_volunteer == 0 )? "non" : "oui";
                    }
                },
                {
                    data: "profile_data_status_id",
                    render: function (data, type, row) {
                        return (row.profile_data_status_id == 1 )? "oui" : "non";
                    }
                },
                {
                    data: "driving_licence_status_id",
                    render: function (data, type, row) {
                        return (row.driving_licence_status_id == 1 )? "oui" : "non";
                    }
                },
                {
                    data: "user.country",
                    render: function (data, type, row) {
                       // if(row.user.country_id == null ){ return 'non renseigné'; }
                       // if(row.user.country_id == 7 ){ return 'oui'; }
                       // if(row.user.country_id != 7 ){ return 'non'; }
                        return row.user.country;
                    }
                },


            ],
            "columnDefs": [
                {
                    "targets": [ 1 ],
                    "visible": false,
                    "searchable": true
                },
                {
                    "targets": [ 7 ],
                    "visible": false,
                    "searchable": true
                },
                {
                    "targets": [ 8 ],
                    "visible": false,
                    "searchable": true
                },
                {
                    "targets": [ 9 ],
                    "visible": false,
                    "searchable": true
                },
                {
                    "targets": [ 10 ],
                    "visible": false,
                    "searchable": true
                },
                {
                    "targets": [ 11 ],
                    "visible": false,
                    "searchable": true
                },

            ],
            drawCallback: function () {
                if (!this.api().data().length) {
                    $('.dataTables_paginate .pagination').css('visibility', 'hidden')
                }
            },
            processing: true,
            serverSide: true,
            lengthChange: true,
            lengthMenu: [ 10, 25, 50, 100, 1000 ] ,
            autoWidth: false,
            responsive: true,
            dom: 'frtiplB',
            buttons: [
                'csvHtml5'
            ],
            // initComplete: function() {
            //     let $container = $(this.api().table().container()).find('.dataTables_filter');

            //     $(`
            //     // <div class="custom-control custom-switch d-inline disabled-only-filter table-filtres-items column">
            //     //     <div class="labels d-flex align-items-center">
            //     //         <input
            //     //             class="custom-control-input affiche_filtre form-control"
            //     //             name="disabled-only"
            //     //             id="disabled-only"
            //     //             type="checkbox"
            //     //             value="true"
            //     //         >
            //     //         <span>Afficher les filtres</span>
            //     //         <label for="disabled-only" class="custom-control-label ml-2" ></label>
            //     //     </div>
            //     // </div>
            // `).prependTo($container);
            // }
        });

        $(':checkbox').on('change', function() {
            table.columns().every(function() {
              this.search('');
            });
            $(':checkbox:checked').each(function () {
              table.columns($(this).attr('name')).search($(this).val());
            });
            table.draw();
          });

          $('.custom_filtre').hide();

        //   $('.affiche_filtre').on('click',function(){
        //       $('.custom_filtre').toggle('hide');
        //   });

          $('#country_id').on('change',function(){


                table.columns().every(function() {
                  this.search('');
                });

                $(':checkbox:checked').each(function() {
                  table.columns($(this).attr('name')).search($(this).val());
                });

                if($(this).val() != "all"){
                    table.columns(9).search($(this).val());
                }


                table.draw();
          });


        let $editUserModal = $('#consultant-activities-edit-user-modal');
        ExaHelpers.bindCandidateInfoModal($editUserModal);
    }
}
